import variableColors from "@/base/global/variables/figma.colors.json";
import variableTypography from "@/base/global/variables/figma.typography.json";

export const inputThemeToken: any = {
  activeBg: variableColors["ColorFigmaNeutralWhiteWhite100"],
  activeBorderColor: variableColors["ColorFigmaComplementaryBlue50"],
  hoverBorderColor: variableColors["ColorFigmaComplementaryBlue50"],
  searchButtonColor: variableColors["ColorFigmaNeutralGrayscaleGray70"],
  colorBorder: variableColors["ColorFigmaNeutralGrayscaleGray40"],
  iconSize: 24,
  colorTextPlaceholder: variableColors["ColorFigmaNeutralGrayscaleGray70"],

  //========================= SIZE =================================/
  controlHeight: 40,
  controlHeightLG: 48,
  controlHeightSM: 36,
  paddingBlock: 9,
  paddingBlockLG: 13,
  paddingBlockSM: 7,
  paddingInline: 9,
  paddingInlineLG: 9,
  paddingInlineSM: 7,

  //========================= FONT =================================/
  inputFontSize: variableTypography["BodyMediumFontSize"],
  inputFontSizeLG: variableTypography["BodyLargeFontSize"],
  inputFontSizeSM: variableTypography["BodySmallFontSize"],
  lineHeight: variableTypography["BodyMediumLineHeight"],
  lineHeightLG: variableTypography["BodyMediumLineHeight"],
  colorText: variableColors["ColorFigmaNeutralGrayscaleGray90"],
  fontFamily: variableTypography["BodyMediumFontFamily"],

  //========================= DISABLED =================================/
  colorBgContainerDisabled: variableColors["ColorFigmaNeutralGrayscaleGray30"],
  colorTextDisabled: variableColors["ColorFigmaNeutralGrayscaleGray60Disabled"],

  //========================= DESCRIPTION =================================/
  colorTextDescription: variableColors["ColorFigmaNeutralGrayscaleGray70"],

  activeShadow: "none",
  errorActiveShadow: "none",
  warningActiveShadow: "none",
};
